import React from "react";
import { ErrorBoundaryBS } from "./ErrorBoundaryBS";

export const withErrorBoundaryBS = <Props,>(Component: React.ComponentType<Props>, boundaryName: string) => {
  return (props: Props & React.JSX.IntrinsicAttributes) => (
    <ErrorBoundaryBS boundaryName={boundaryName}>
      <Component {...props} />
    </ErrorBoundaryBS>
  );
};
